import { Directive } from '@angular/core';

@Directive({
  selector: '[appSegment]'
})
export class SegmentDirective {

  constructor() { }

}
